module.exports = __webpack_public_path__ + "img/fwhz.3df0f213.png";